module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_9006.5a2efbbc.png";